import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { unMaskCurrency } from '@utils/masks/unMaskCurrency'

export const addEditAdditionalDepreciationSchema = yupResolver(
  yup.object({
    accountDescription: yup.string().required('Descrição da conta é obrigatória'),
    accountNumber: yup.string().required('Número da conta é obrigatório'),
    additionalDepreciationValue: yup
      .string()
      .required('Valor da depreciação adicional é obrigatório')
      .test('is-number', 'Valor inválido', (value) => !isNaN(unMaskCurrency(value))),
    observations: yup.string().trim().required('Observações é obrigatória')
  })
)
